import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
import { HiAcademicCap, HiLocationMarker, HiCalendar, HiStar } from 'react-icons/hi'
import type { Language } from '../App'
import { t } from '../utils/translations'
import { education } from '../utils/data'
import './Education.css'

interface EducationProps { language: Language }

export default function Education({ language }: EducationProps) {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true })

  return (
    <section id="education" className="section-alt" ref={ref}>
      <div className="orb orb-cyan edu-orb" />
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ y: 30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
        >
          <p className="section-label">{t('edu.label', language)}</p>
          <h2 className="section-title">{t('edu.title', language)}</h2>
          <div className="gradient-divider" />
          <p className="section-desc">{t('edu.desc', language)}</p>
        </motion.div>

        <div className="edu-grid">
          {education.map((edu, i) => (
            <motion.div
              key={edu.id}
              className="edu-card card"
              initial={{ y: 50, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15 }}
            >
              <div className="edu-icon-wrap">
                <HiAcademicCap />
              </div>

              <div className="edu-body">
                <h3 className="edu-degree">{edu.degree}</h3>
                <p className="edu-institution">{edu.institution}</p>

                <div className="edu-meta">
                  <span className="info-item"><HiCalendar />{edu.period}</span>
                  <span className="info-item"><HiLocationMarker />{edu.location}</span>
                  <span className="info-item grade"><HiStar />{edu.grade}</span>
                </div>

                <p className="edu-description">{edu.description}</p>

                <div className="edu-tags">
                  {edu.highlights.map(h => (
                    <span key={h} className="tag">{h}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
